<!-- CheckerPrint.vue -->
<template>
  <div :class="['checker-container', ishide ? 'hidden' : '']"  ref="checker">
    <!-- Order Info -->
    <div class="order-info">
      <!-- <div class="order-number">#2</div> -->
      <div class="order-id">#{{ orderId }} ({{ new Date(orderTime).toLocaleTimeString([], {
        hour: '2-digit', minute:
          '2-digit', second: '2-digit'
      }) }})</div>
      <div class="sender">Tipe Transaksi : {{ typeTransaction }}</div>
      <div class="location">Lokasi : {{ location }}</div>
      <div class="waiter">Waiter : {{ waiter }}</div>
      <div class="sender">Sender : {{ sender }}</div>
    </div>

    <!-- Bar Items -->
    <div class="bar-section">
      <div class="section-title" id="checker-division">{{ division }}</div>
      <div class="item-list">
        <div v-for="(item, index) in items" :key="index" class="item">
          <span class="quantity">{{ item.quantity }}</span>
          <span class="name">{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckerPrint',
  props: {
    orderNumber: {
      type: String,
      default: '2'
    },
    orderId: {
      type: String,
      default: '171224016'
    },
    orderTime: {
      type: String,
      default: new Date()
    },
    orderType: {
      type: String,
      default: 'Dine-In VIP.04'
    },
    location: {
      type: String,
      default: 'VIP LT-1'
    },
    waiter: {
      type: String,
      default: 'Default'
    },
    sender: {
      type: String,
      default: 'NANDA SERVER'
    },
    division: {
      type: String,
      default: 'BAR'
    },
    typeTransaction: {
      type: String,
      default: 'Dine-In'
    },
    items: {
      type: Array,
      default: () => [
        { quantity: 1, name: 'MINERAL WATER' },
        { quantity: 2, name: 'FREE GREEN TEA' },
        { quantity: 2, name: 'KRATINGDAENG' }
      ]
    },
    ishide: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.checker-container {
  font-family: monospace;
  width: 80mm;
  padding: 5mm;
  font-size: 20px;
}

.order-info {
  margin-bottom: 10px;
}

.order-number {
  font-size: 24px;
  font-weight: bold;
}

.order-id,
.order-type,
.location,
.waiter,
.sender {
  margin: 2px 0;
}

.section-title {
  font-weight: bold;
  margin: 5px 0;
}

.item-list {
  margin-left: 5px;
}

.item {
  display: flex;
  gap: 10px;
  margin: 2px 0;
}

.quantity {
  min-width: 20px;
}

@media print {
  @page {
    margin: 0;
    size: 80mm auto;
  }

  body {
    margin: 0;
  }

  .checker-container {
    width: 100%;
  }
}
</style>